import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';

import DialogBox from '../components/options/DialogBox';
import EditPopup from '../components/options/EditPopup';
import ChangePassword from '../screens/Auth/Forgot/ChangePassword.component';
import ForgotPassword from '../screens/Auth/Forgot/Forgot.component';
import LogInContainer from '../screens/Auth/Login/Login.container';
import SignUpContainer from '../screens/Auth/SignUp/SignUp.container';
import MainContainer from '../screens/Main/Main.container';
import Home from '../screens/Onbording/Home/Home.container';
import Partnerships from '../screens/Onbording/Partnership/Partnership.component';
import Price from '../screens/Onbording/Prices/Prices.component';
import Themes from '../screens/Onbording/Themes/Themes.component';
import PrivacyPolicy from '../screens/Support/privacyPolicy';
import Service from '../screens/Support/Terms_of_service';
export default function Navigator() {
	return (
		<>
			<DialogBox />
			<EditPopup />
			<BrowserRouter>
				<Switch>
					<Route exact path='/'>
						<Home />
					</Route>
					<Route path='/themes'>
						<Themes />
					</Route>
					<Route path='/login' component={LogInContainer} />
					<Route path='/signup' component={SignUpContainer} />
					<Route path='/forgot-password' component={ForgotPassword} />
					<Route path='/new-password' component={ChangePassword} />
					<Route path='/privacy-policy'>
						<PrivacyPolicy />
					</Route>
					<Route path='/terms-of-service'>
						<Service />
					</Route>
					<Route path='/partnership'>
						<Partnerships />
					</Route>
					<Route path='/price'>
						<Price />
					</Route>
					<Route exact path='/home'>
						<Home />
					</Route>
					<Route path='/:username' component={MainContainer} />
					<Redirect to='/' />
				</Switch>
			</BrowserRouter>
		</>
	);
}
